//import Userfront from "@userfront/core";
//Userfront.init("6bgdz9n7");

export function LogOut() {
  if (window.navigator.cookieEnabled) {
      document.cookie = "id.6bgdz9n7= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
      document.cookie = "access.6bgdz9n7= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
      document.cookie = "refresh.6bgdz9n7= ; expires = Thu, 01 Jan 1970 00:00:00 GMT"
  } else {
      console.log("There could be problems as cookies are not enabled.")
  }
  
  window.location.href = "/index.html"
}

export function checkCookie(cname) {
  let answer = getCookie(cname);
  console.log("Cookie answer is: " + answer)
  return (answer != "" && answer != null) 
}

export function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getFaunaError(error) {

    const { code, description } = error.requestResult.responseContent.errors[0];
    let status;
  
    switch (code) {
      case 'unauthorized':
      case 'authentication failed':
        status = 401;
        break;
      case 'permission denied':
        status = 403;
        break;
      case 'instance not found':
        status = 404;
        break;
      case 'instance not unique':
      case 'contended transaction':
        status = 409;
        break;
      default:
        status = 500;
    }
  
    return { code, description, status };
  }
  
  export function getName() {
    if( checkCookie('id.6bgdz9n7') ) {
        const idToken = getCookie('id.6bgdz9n7')
        console.log("Access token in getName:" + idToken)

        const payload = idToken.split('.')[1]
        console.log("This is access token payload:" + payload)

        const jstring = atob(payload)//.toString('base64') //TODO: change deprecated  function
        console.log("This is result decoded access token payload:" + jstring)

        const obj = JSON.parse(jstring)

        console.log("This is parsed name:" + obj.name)
        
        return obj.name
    }
    else {
        console.log("Error getting name from cookie.")
        return ""
      } 
    }

  //   export function submitForm(e, form, dest, method){
  //     e.preventDefault();
      
  //     fetch(dest, {
  //       method: method,
  //       body: JSON.stringify({name: form.formName.value, email: form.formEmail.value})
  //     }).then(function(response) {
  //       return response.json();
  //     }).then(function(data) {
  //       //Success code goes here
  //       alert('form submited')
  //     }).catch(function(err) {
  //       //Failure
  //       alert('Error')
  //     });
  // }

  export function str2ab(str) {
    const buf = new ArrayBuffer(str.length);
    const bufView = new Uint8Array(buf);
    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i);
    }
    return buf;
  }